import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api, useAuth } from "@/auth/AuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const hash = location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) { navigate("/login", { replace: true }); return; }
    const session_id = decodeURIComponent(match[1]);
    (async () => {
      try {
        const res = await api.post("/auth/emergent-session", { session_id });
        if (res.data?.token) localStorage.setItem("jwt_token", res.data.token);
        window.history.replaceState({}, document.title, window.location.pathname);
        await refresh();
        navigate("/padma", { replace: true });
      } catch (err) {
        const detail = err?.response?.data?.detail || "Login Emergent gagal. Coba lagi.";
        navigate("/login", { replace: true, state: { error: detail } });
      }
    })();
  }, [location.hash, navigate, refresh]);

  return <div className="loading-screen">Memproses login…</div>;
}
